import React from 'react';
import { useTranslation } from 'react-i18next';
import { SectionWrapper } from 'pages/SettingsPage/General/GeneralSettings.styled';
import { NotificationSwitch } from 'pages/SettingsPage/NotificationCenter/NotificationUtils/NotificationSwitch';
import { Flex, PaddingBox, Text } from 'UI';

interface Props {
  value: boolean;
  onChange: (value: boolean) => void;
  enabled: boolean;
}

const AllowMktpDeliveryOptions = ({ value, onChange, enabled }: Props) => {
  const { t } = useTranslation();

  return (
    <SectionWrapper data-cy={'allow-mktp-delivery-options'} $marginY={15}>
      <Flex direction={'column'} gap={15}>
        <Text type="heading4">
          {t('backoffice.central-settings.allow-mktp-delivery-options.title', 'Delivery Options')}
        </Text>
        <Text type="base">
          {t(
            'backoffice.central-settings.allow-mktp-delivery-options.description',
            // eslint-disable-next-line max-len
            'Allow MKTP clients to choose between receiving all products in a single delivery or in multiple separate deliveries at checkout.',
          )}
        </Text>
        <PaddingBox px={15} pb={10} pt={5}>
          <NotificationSwitch
            title={t(
              'backoffice.central-settings.allow-mktp-delivery-options.switch.title',
              'Unique / Multiple Deliveries',
            )}
            label={t(
              'backoffice.central-settings.allow-mktp-delivery-options.switch.description',
              'When enabled, the selected mode is transmitted to RP4.',
            )}
            isEnabled={value}
            onChange={onChange}
            disabled={!enabled}
            data-cy={'allow-mktp-delivery-options-switch'}
          />
        </PaddingBox>
      </Flex>
    </SectionWrapper>
  );
};

export default AllowMktpDeliveryOptions;
